import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'    //  默认主题
import VueI18n from 'vue-i18n'
import messages from './i18n/langs'
import router from './router/router'
import './common/element-theme/index.css'   //  自定义主题  #ED4217
import './common/styles/index.less'
import store from './store'
import animated from 'animate.css'
import 'nprogress/nprogress.css'// progress bar style
import './permission'
// import './icons'
import _ from 'lodash'
import { clickoutside } from  '@/directives/clickoutside'
import { focus } from '@/directives/focus'
import { has } from '@/directives/hasPremission'
// import './mock'
import './api'
import Storage from '@/utils/storage'

import XLSX from "xlsx";
import FileSaver from "file-saver";
import tableexport from '@/utils/tableexport'

//引入echarts
import echarts from 'echarts'

Vue.use(VueI18n)
Vue.use(animated)
Vue.use(clickoutside)
Vue.use(focus)
Vue.use(has)
Vue.use(tableexport)

Vue.prototype.$echarts = echarts
Vue.prototype._ = _

const lang = Storage.get('lang');
const i18n = new VueI18n({
    locale: lang ? lang.lang : 'cn',
    messages
})

Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
})

Vue.config.productionTip = false

new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
